import React from "react";

import { Provider } from "react-redux";

import store from "./src/context/index";

import "bootstrap/dist/js/bootstrap.bundle.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import all CSS dependencies
import "./src/scss/styles.scss";

export const wrapRootElement = ({ element }) => {
  // const store = configureStore();
  return <Provider store={store}>{element}</Provider>;
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const { pathname } = location;
  // list of routes for the scroll-to-top-hook

  window.scrollTo(0, 0);

  return false;
};
